export const ReportTypeEnum = {
  GRID: 'GRID',
  PIVOT: 'PIVOT',
  EXCEL_SHEET: 'EXCEL_SHEET',
} as const;

export type ReportViewType = (typeof ReportTypeEnum)[keyof typeof ReportTypeEnum];

export interface KlReportStartPayload {
  report_type: ReportViewType;
}
